import { message } from 'antd';
import Cookies from 'js-cookie';
import { API_ENDPOINTS } from '@/config/api';

// 简单的请求函数
async function fetchProfile(token) {
  try {
    const res = await fetch(API_ENDPOINTS.PROFILE, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) {
      throw new Error('Failed to fetch profile');
    }
    return await res.json();
  } catch (e) {
    console.error('Fetch profile error:', e);
    throw e;
  }
}

export async function getInitialState() {
  const token = Cookies.get('admin_token');
  console.log('[getInitialState] token:', token ? 'exists' : 'none');
  
  if (token) {
    try {
      const user = await fetchProfile(token);
      console.log('[getInitialState] user:', user);
      return { currentUser: user, isAuthenticated: true };
    } catch (e) {
      console.error('[getInitialState] error:', e);
      Cookies.remove('admin_token', { path: '/' });
      return { currentUser: null, isAuthenticated: false };
    }
  }
  return { currentUser: null, isAuthenticated: false };
}
